// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"schedulePreRecordedVideo_scrollbar__14PVD"};